import Model, { attr, belongsTo } from '@ember-data/model';
import { copyable, caption, arrayAttr } from 'eflex/decorators';

@copyable
class SpindleConfig extends Model {
  @attr('boolean', { defaultValue: true }) enabled;
  @arrayAttr captions;
  @caption name;

  @belongsTo('task-config', { async: false, inverse: 'spindleConfigs' }) taskConfig;
  @belongsTo('spindle', { async: false, inverse: 'spindleConfigs' }) spindle;

  get copyableOptions() {
    return {
      ignoreAttributes: new Set(['spindle', 'taskConfig']),
    };
  }
}

export default SpindleConfig;
